import React from 'react';
import styles from './ToolDock.module.css';
import {SelectIcon, OvalIcon, NoteIcon} from './EditorIcons';

const TOOLS = [
    {mode: '1', label: 'Select', Icon: SelectIcon},
    {mode: '2', label: 'Oval', Icon: OvalIcon},
    {mode: '3', label: 'Note', Icon: NoteIcon},
];

const HINTS = {
    2: {desktop: 'Drag around part of the diagram to draw a task oval', mobile: 'Drag your finger around part of the diagram to draw a task oval'},
    3: {desktop: 'Click anywhere on the page to stick a note', mobile: 'Tap anywhere on the page to stick a note'},
};

// The floating Select / Oval / Note dock, bottom-centre of the canvas, with
// a one-time-per-session hint shown above it for Oval/Note.
const ToolDock = ({mode, onModeChange, hintDismissed, onDismissHint}) => {
    const hint = HINTS[mode];

    return (
        <>
            {hint && !hintDismissed && (
                <div className={styles.hint} onClick={onDismissHint}>
                    <span className={styles.hintDesktop}>{hint.desktop}</span>
                    <span className={styles.hintMobile}>{hint.mobile}</span>
                </div>
            )}
            <div role="toolbar" aria-label="Tools" className={styles.dock}>
                {TOOLS.map(({mode: toolMode, label, Icon}) => (
                    <button
                        key={toolMode}
                        type="button"
                        aria-pressed={mode === toolMode}
                        className={styles.tool}
                        onClick={() => onModeChange(toolMode)}
                    >
                        <Icon/>
                        {label}
                    </button>
                ))}
            </div>
        </>
    );
};

export default ToolDock;
